<c-card *transloco="let t">
  <c-card-body>
    <c-row class="mb-3">
      <c-col>
        <h1>{{ t('Alert Zone Intelligence Notifications') }}</h1>
        <p class="text-muted">{{ t('View push notification history for your custom threat areas.') }}</p>
      </c-col>
      <c-col class="col-auto text-lg-end">
        <button cButton class="btn btn-light" routerLink="/mgmt/threats">
          <i class="fa-solid fa-arrow-left"></i> {{ t('Back') }}
        </button>
      </c-col>
    </c-row>



    <form cForm class="row g-2 align-items-end mb-3" [formGroup]="formGroup" (ngSubmit)="updateFilter()">
      <c-col class="col-12 col-lg-3">
        <label cLabel>{{ t('Worker') }}</label>
        <select cSelect formControlName="worker_id">
          <option value="">{{ t('All Workers') }}</option>
          <option *ngFor="let worker of workers" [value]="worker.worker_id">{{ worker.name }} ({{ worker.pin }})</option>
        </select>
      </c-col>
      <c-col class="col-6 col-lg-2">
        <label cLabel>{{ t('Sent From') }}</label>
        <input cFormControl type="date" formControlName="sent_from" />
      </c-col>
      <c-col class="col-6 col-lg-2">
        <label cLabel>{{ t('Sent Until') }}</label>
        <input cFormControl type="date" formControlName="sent_until" />
      </c-col>
      <c-col class="col-auto">
        <button cButton class="btn btn-light" type="submit">
          <i class="fa-solid fa-magnifying-glass"></i> {{ t('Search') }}
        </button>
      </c-col>
      <c-col class="col-12 col-lg-3 text-lg-end" *ngIf="pagination.totalPages > 1">
        <c-input-group>
          <span cInputGroupText><i class="fa-solid fa-arrow-down-1-9"></i></span>
          <select cSelect [(ngModel)]="pagination.page" [ngModelOptions]="{standalone: true}" (change)="changePage()">
            <option *ngFor="let p of pagination.pageArray" [value]="p">{{ p }}</option>
          </select>
        </c-input-group>
      </c-col>
    </form>

    @if(notifications) {

    <table [hover]="true" [responsive]="true" [striped]="true" align="middle" cTable class="mb-0 border">
      <thead>
        <tr>
          <th scope="col">{{ t('Sent At') }}</th>
          <th scope="col">{{ t('Worker') }}</th>
          <th scope="col">{{ t('Threat') }}</th>
          <th scope="col">{{ t('Category') }}</th>
          <th scope="col">{{ t('Severity') }}</th>
          <th scope="col">{{ t('Alert Type') }}</th>
          <th scope="col">{{ t('Distance (miles)') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let notification of notifications">
          <td class="text-nowrap">{{ notification.sent_at_local || notification.sent_at }}</td>
          <td>{{ notification.worker?.name || notification.worker_id }}</td>
          <td><b>{{ notification.threat_zone?.event || notification.threat_zone_id }}</b></td>
          <td>
            <span class="badge bg-secondary">
              {{ formatLabel(notification.category) }}
            </span>
          </td>
          <td>
            <span class="badge" [ngStyle]="severityBadgeStyle(notification.severity)">
              {{ notification.severity }}
            </span>
          </td>
          <td>
            <span class="badge" [ngStyle]="alertTypeBadgeStyle(notification.alert_type)">
              {{ formatLabel(notification.alert_type) }}
            </span>
          </td>
          <td>{{ notification.distance_miles != null ? (notification.distance_miles | number:'1.0-1') + ' mi' : '—' }}</td>
        </tr>
      </tbody>
    </table>

    <p class="text-muted mt-3" *ngIf="notifications.length === 0">{{ t('No notifications found.') }}</p>

  }
  </c-card-body>
</c-card>
